module.exports = __webpack_public_path__ + "img/product_117.827d0d5.webp";